module.exports = __webpack_public_path__ + "img/jpg_empty.a2442417.png";